import { render, staticRenderFns } from "./edit-chip.vue?vue&type=template&id=c74a4b96&scoped=true&"
import script from "./edit-chip.vue?vue&type=script&lang=js&"
export * from "./edit-chip.vue?vue&type=script&lang=js&"
import style0 from "./edit-chip.vue?vue&type=style&index=0&id=c74a4b96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74a4b96",
  null
  
)

export default component.exports